
import Vue from 'vue';

export default Vue.extend({
	props: {
		id: { type: String, required: true },
		toaster: { type: String, default: 'b-toaster-top-right' },
		variant: { type: String, default: 'primary' },
		visible: { type: Boolean, default: false },
		autoHideDelay: { type: Number, default: 5000 },
		solid: { type: Boolean, default: true },
		noHoverPause: { type: Boolean, default: false },
	},

	methods: {
		emitHidden(): void {
			this.$emit('hidden', this.id);
		},
	},
});
